import { Anchor, Box, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { LogoutProps } from "./UserMenu";

import { Modal } from "@/components/elements";

import type { FC } from "react";

export type ContactModalProps = {
  opened: boolean;
  onClose: () => void;
  logout?: LogoutProps;
};

const ContactModal: FC<ContactModalProps> = ({ opened, onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal
      opened={opened}
      fullScreen
      onClose={onClose}
      overlayProps={{
        backgroundOpacity: 0.55,
        blur: 3,
      }}
      styles={{
        header: {
          paddingBottom: 0,
        },
        close: {
          color: "#143ab1",
        },
        body: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        },
      }}
    >
      <Box>
        <Text ta="center" size="lg" fz="h2" pb="lg">
          {t("header.help.title")}
        </Text>
        <Text ta="start">{t("header.help.message")}</Text>
        <Anchor href={`mailto:${t("header.help.email")}`} mt="sm">
          {t("header.help.email")}
        </Anchor>
      </Box>
    </Modal>
  );
};

export default ContactModal;
